module.exports = __webpack_public_path__ + "img/social_media_wechat.8fb948ab.png";